import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { groupsSelector } from "@store/groups/groups-selector";
import { fetchGroups } from "@store/groups/groups-slice-thunk";
/** A hook that returns all groups the user has access to */
export function useGroups() {
  const $ = _c(4);
  const companyId = useCompanyId();
  const dispatch = useAppDispatch();
  const groups = useAppSelector(groupsSelector);
  let t0;
  let t1;
  if ($[0] !== companyId || $[1] !== dispatch) {
    t0 = () => {
      const fetchGroupsViaStore = async function fetchGroupsViaStore() {
        await dispatch(fetchGroups({
          companyId
        }));
      };
      fetchGroupsViaStore();
    };
    t1 = [companyId, dispatch];
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return groups;
}